import { useCallback } from 'react';
import useStyle from '../styles/promocodesPanel';
import { Cell } from 'react-table';
import { EStatus } from '../types/enums/EStatus';

/**
 * used in customer view component
 *
 */
const useCellStatusStyleHandler = () => {
  const styles = useStyle();

  const cellStyleHandler = useCallback((cell: Cell<any, any>) => {
    let rowStyle = '';
    let cellStyle = '';
    let columnStyle = '';

    if (cell.row.values['status'] === EStatus.Used) {
      rowStyle = styles.promocodesStatusUsed;
    }
    if (cell.column.id === 'status' && cell.value === EStatus.Active) {
      cellStyle = styles.promocodesStatusActive;
    }
    if (cell.column.id === 'code') {
      columnStyle = styles.promocodesCodeColumn;
    }

    return `${styles.promocodesTableCell} ${columnStyle} ${rowStyle} ${cellStyle}`;
  }, []);

  return cellStyleHandler;
};

export default useCellStatusStyleHandler;
